import {
  AliCheckLoginNew,
  SendAliSmsCode,
  SendRegSmsCodeNew,
  SendAliSmsCodes,
} from '@/services/index';
import { catchException } from '@/utils/utils';

export default {
  namespace: 'newlogin',

  state: {},

  effects: {
    *AliCheckLoginNew({ payload, callback }, { call, put }) {
      const response = yield call(AliCheckLoginNew, payload);
      yield catchException(function*() {
        callback && callback.success(response);
      });
    },

    *SendAliSmsCode({ payload, callback }, { call, put }) {
      const response = yield call(SendAliSmsCode, payload);
      yield catchException(function*() {
        callback && callback.success(response);
      });
    },

    *SendRegSmsCodeNew({ payload, callback }, { call, put }) {
      const response = yield call(SendRegSmsCodeNew, payload);
      yield catchException(function*() {
        callback && callback.success(response);
      });
    },

    *SendAliSmsCodes({ payload, callback }, { call, put }) {
      const response = yield call(SendAliSmsCodes, payload);
      yield catchException(function*() {
        callback && callback.success(response);
      });
    },
  },

  reducers: {},
};
